interface IFilter {
  data: {
    id: number
    codigo?: string
    descricao: string
  }[]
}

interface IParsedFilters {
  value: string | number
  label: string
}

interface IParams {
  [key: string]: {
    value: number
    label: string
  }[]
}

interface IParsedParams {
  [key: string]: number[]
}

const parse = (filters: IFilter): IParsedFilters[] => {
  return filters.data.map(filter => ({
    value: filter.codigo ? Number(filter.codigo) : filter.id,
    label: filter.descricao
  }))
}

const parseAlert = (filters: IFilter): IParsedFilters[] => {
  return filters.data.map(filter => ({
    value: filter.codigo ? Number(filter.codigo) : filter.id,
    label: filter.id + ' - ' + filter.descricao
  }))
}

const params = (params: IParams): IParsedParams => {
  let result: IParsedParams = {}

  const keys = Object.keys(params)

  for (let i = 0; i < keys.length; i++) {
    const obj: { [key: string]: number[] } = {}

    if (keys[i] === 'curvaAbc') {
      continue
    }

    obj[keys[i]] = params[keys[i]].map(param => param.value)

    result = Object.assign(result, obj)
  }

  return result
}

export default {
  parse,
  parseAlert,
  params
}
